var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resize-drag",on:{"mousedown":_vm.mousedown}},[(_vm.isResizing)?_c('div',{staticClass:"resize-blanket",on:{"mouseup":_vm.mouseup}}):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resize-center"},[_c('div',{staticClass:"resize-marker"}),_c('div',{staticClass:"resize-marker"})])
}]

export { render, staticRenderFns }